//src/components/steps/Step0OwnerInfo.jsx
import { MdEmail, MdPerson, MdPhone } from 'react-icons/md';
import { useSellProperty } from '../SellPropertyContext';
import { FormField, InputIcon, StepSection } from '../SellPropertyUI';

const RequiredMark = () => <span style={{ color: '#ef4444', marginLeft: 4 }}>*</span>;

const Step0OwnerInfo = () => {
    const { form, errors, handleChange } = useSellProperty();

    return (
        <StepSection
            icon={<MdPerson size={20} color="var(--color-primary)" />}
            title="Informasi Pemilik Properti"
            desc="Data ini digunakan untuk dihubungi oleh tim dan calon pembeli."
        >
            <div className="sell-grid">
                <FormField
                    label={
                        <>
                            Nama Lengkap <RequiredMark />
                        </>
                    }
                    error={errors.ownerName}
                >
                    <div className="sell-input-wrap">
                        <InputIcon>
                            <MdPerson size={16} />
                        </InputIcon>
                        <input
                            className={`mp-input sell-input-padded${errors.ownerName ? ' error' : ''}`}
                            type="text"
                            name="ownerName"
                            placeholder="Nama sesuai KTP"
                            value={form.ownerName}
                            onChange={handleChange}
                        />
                    </div>
                </FormField>

                <FormField
                    label={
                        <>
                            Nomor WhatsApp Aktif <RequiredMark />
                        </>
                    }
                    error={errors.ownerPhone}
                >
                    <div className="sell-input-wrap">
                        <InputIcon>
                            <MdPhone size={16} />
                        </InputIcon>
                        <input
                            className={`mp-input sell-input-padded${errors.ownerPhone ? ' error' : ''}`}
                            type="tel"
                            name="ownerPhone"
                            placeholder="0812-3456-7890"
                            value={form.ownerPhone}
                            onChange={handleChange}
                        />
                    </div>
                </FormField>

                <FormField label="Email (Opsional)" fullWidth error={errors.ownerEmail}>
                    <div className="sell-input-wrap">
                        <InputIcon>
                            <MdEmail size={16} />
                        </InputIcon>
                        <input
                            className={`mp-input sell-input-padded${errors.ownerEmail ? ' error' : ''}`}
                            type="email"
                            name="ownerEmail"
                            placeholder="email@mail.com"
                            value={form.ownerEmail}
                            onChange={handleChange}
                        />
                    </div>
                </FormField>
            </div>
        </StepSection>
    );
};

export default Step0OwnerInfo;
